import {GraphyoEmbedded,type GraphyoProps} from './GraphyoEmbedded';
export {flushGraphyoAnswers} from './GraphyoEmbedded';

// The preset configures the document; every activity uses the same Graphyo workspace.
export function GraphyoActivity(props:GraphyoProps){
 return <GraphyoEmbedded {...props}/>;
}
